import { type ClassValue, clsx } from 'clsx'
import React from 'react'
import { twMerge } from 'tailwind-merge'

export const cn = function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function getValidChildren(children: React.ReactNode) {
    return React.Children.toArray(children).filter(child => React.isValidElement(child)) as React.ReactElement[]
}
